export const UPDATE_DATA = 'app/EditSessionPage/Date/UPDATE';
export const UPDATE_VARIABLE = 'app/EditSessionPage/Date/UPDATE_VARIABLE';
